import PropTypes from "prop-types";
import React from "react";
import TimeToSellChart from "../../common/TimeToSellChart";
import { useLive } from "../LiveProvider";

export default function LiveTimeToSellChart({
  hoverListingId,
  previewListingId,
  setPreviewListingId
}) {
  const { visibleListings } = useLive();

  return (
    <TimeToSellChart
      listings={visibleListings}
      hoverListingId={hoverListingId}
      previewListingId={previewListingId}
      setPreviewListingId={setPreviewListingId}
    />
  );
}

LiveTimeToSellChart.defaultProps = {
  setPreviewListingId: () => {}
};

LiveTimeToSellChart.propTypes = {
  hoverListingId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  previewListingId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setPreviewListingId: PropTypes.func
};
